import AdvancedFilters from './Advanced/AdvancedFilters.inner.js';
import EqualFilter from './Equal/EqualFilter.inner.js';
import Filters from './Filters';
import InFilter from './In/InFilter.inner.js';
import RangeFilter from './Range/RangeFilter.inner.js';
import { typeFilters } from './FiltersConstants.inner.js';
import ContainsFilter from './Contains/ContainsFilter.inner.js';

import { withFilterContext, useFilterContext } from './FilterContext.inner.js';

const Filter = {
  Equal: EqualFilter,
  Range: RangeFilter,
  In: InFilter,
  Contains: ContainsFilter,
};

const Equal = (props) => withFilterContext(Filter.Equal, props);
const Range = (props) => withFilterContext(Filter.Range, props);
const In = (props) => withFilterContext(Filter.In, props);

export {
  Equal,
  Range,
  In,
  Filter,
  withFilterContext,
  useFilterContext,
  AdvancedFilters,
  typeFilters,
};

export default Filters;
